import React from 'react';
import ReactDOM from 'react-dom';
import Main from './main';
import './index.css';
import firebase from "firebase/app";
import 'firebase/database';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBy2joK2hnPDT0CjxCFwc3rCAAZzERliws",
  authDomain: "describe-anger.firebaseapp.com",
  databaseURL: "https://describe-anger-default-rtdb.firebaseio.com",
  projectId: "describe-anger",
  storageBucket: "describe-anger.appspot.com",
  messagingSenderId: "392702355368",
  appId: "1:392702355368:web:77313d7f166baf2e02df9d"
};
firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <Main firebase={firebase}/>
  </React.StrictMode>,
  document.getElementById('root')
);